import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { MsalService } from '@azure/msal-angular';
import { AppSettingsService } from '~/core/services/appsettings.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(
        private readonly router: Router,
        private readonly appSettingsService: AppSettingsService,
        private readonly msalService: MsalService,
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            // Check if MSAL has an active/authenticated account
            const msalAccount = this.msalService.instance.getActiveAccount()
                || this.msalService.instance.getAllAccounts()[0];

            if (msalAccount) {
                // User is authenticated with MSAL - allow access
                return true;
            }

            // No MSAL account - user is not authenticated
            // Store the intended URL for post-login redirect
            if (!sessionStorage.getItem("_redirect")) {
                sessionStorage.setItem("_redirect", state.url);
            }

            // Redirect to auth page (which will trigger MSAL login)
            await this.router.navigate(["/auth"]);
            return false;
        } catch (error) {
            console.error('Error in AuthGuard:', error);
            return true; // Allow access on error to avoid infinite loops
        }
    }
}